<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
        <div class="col-md-2">
          <label for="starDate">{{$t('Tarixdən')}}</label>
          <el-date-picker size="small" format="dd.MM.yyyy" id="starDate" type="date" :clearable="false"
            v-model="item.startDate">
          </el-date-picker>
        </div>
        <div class="col-md-2">
          <label for="endDate">{{$t('Tarixədək')}}</label>
          <el-date-picker size="small" format="dd.MM.yyyy" id="endDate" type="date" :clearable="false"
            v-model="item.endDate">
          </el-date-picker>
        </div>
        <div class="col-md-8" style="padding-bottom: 10px">
         <label>{{$t('Axtarış_növü')}}</label>
          <div class="d-flex justify-content-start">
            <div class="d-flex flex-row">
              <el-select style="width: 90%" size="small" v-model="item.searchType">
                <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
                <el-option :label="$t('İş_nömrəsi')" :value="1"></el-option>
                <el-option :label="$t('DQN')" :value="3"></el-option>
                <el-option :label="$t('Məsul_şəxs')"
 :value="4"></el-option>
                <el-option :label="$t('İştirakçılara_görə')" :value="5"></el-option>
              </el-select>
              &nbsp;
              <el-input size="small" :placeholder="$t('Axtar')" @keyup.enter.native="getData" :disabled="item.searchType == 0"
                v-model="item.searchText">
                <template slot="prepend"> </template>
              </el-input>
              &nbsp;
              <el-button size="small" :title="$t('Axtarış')" type="primary" icon="el-icon-search" @click="getData"></el-button>
              &nbsp;
              <download-excel :fields="cells" :data="exportDataList" worksheet="My Worksheet" name="responses">
                <el-button size="small" @click="exportData" type="info"><i class="fa-solid fa-download"></i> {{$t('Export')}}
                </el-button>
              </download-excel>
            </div>
          </div>
        </div>

        <div class="col-md-8 col-12" >
          <div class="d-flex justify-content-start">
            <div class="d-flex flex-row">
              <el-checkbox @change="getData" :active-value="1" :inactive-value="2" v-model="item.zbt">ZBT</el-checkbox>
              &nbsp;&nbsp;&nbsp;
              <el-checkbox @change="getData" :active-value="1" :inactive-value="2"
                v-model="item.subragation">{{$t('Subroqasiya')}}</el-checkbox>
            </div>
          </div>
        </div>

    </div>

    <div class="row">
      <div class="col-12">
        <el-table v-loading="loading" :data="displayData.filter(
          (data) =>
            !search ||
            data.dispClaimNumber
              .toString()
              .toLowerCase()
              .includes(search.toString().toLowerCase()) ||
            data.participants
              .toString()
              .toLowerCase()
              .includes(search.toString().toLowerCase())

        )
          " style="width: 100%">
          >
       <el-table-column :label="$t('İş_#')" sortable prop="dispClaimNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispClaimNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Status')" width="300">
            <template slot-scope="scope">
              <status-label :type="scope.row.statusTypeId === 160
                  ? 'greenYellow'
                  : '' || scope.row.statusTypeId === 161
                    ? 'coral'
                    : '' || scope.row.statusTypeId === 162
                      ? 'green'
                      : ''
                " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>


          <el-table-column :label="$t('Ərazi')" prop="regionName" width="100">
          </el-table-column>
          <el-table-column label="DQN " prop="regNumber" width="100">
          </el-table-column>

          <el-table-column :label="$t('Məbləğ_(AZN)')" prop="paymentSum" width="150">
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs_(İcraçı)')" prop="clientServiceUserName" width="300">
          </el-table-column>

          <el-table-column :label="$t('F4')" width="100">
            <template slot-scope="scope">
              <status-label :type="scope.row.form4Status === 1 ? 'green' : 'red'" />
              {{ scope.row.form4Status === 1 ? 'Var' : "Yoxdur" }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('Subroqasiya')">
            <template slot-scope="scope">
              <status-label :type="scope.row.subragation === 1 ? 'green' : 'red'" />
              {{ scope.row.subragation === 1 ? 'Var' : "Yoxdur" }}
            </template>
          </el-table-column>

          <el-table-column fixed="right" width="50">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleCommand(scope.row.id)" style="padding: 0 !important">
                <div class="square-icon"> <i class="fa-solid fa-up-right-from-square"></i></div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleStatusView(scope.row.id,'claim')" style="padding: 0 !important">
                <div class="square-icon"> <i title="Ümumi Statuslar" class="fa-solid fa-timeline"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>
    <accident-status-view ref="status" />
  </div>
</template>

<script>
import StatusLabel from "../components/StatusLabel.vue";
import { GetClaimsPayment } from "src/services/claim";
import { GetAccident } from "src/services/accident";
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import AccidentStatusView from "../components/AccidentStatusView.vue";
export default {
  components: {
    StatusLabel,
    AccidentStatusView
  },
  data() {
    return {
      loading: false,
      data: [],
      exportDataList: [],
      totalRecords: 0,
      search: "",
      displayData: [],
      filter: {
        page: 1,
        pagesize: 50,
      },
      val: null,
      uid: this.$store.state.user.id,
      item: {
        startDate: null,
        endDate: null,
        searchType: 0,
        searchText: null,
        zbt: false,
        subragation: false,
        dataExport: 0
      },
      cells: {
        'İşin Statusu': 'statusTypeName',
        'İş #': 'dispClaimNumber',
        'Ərazi': 'regionName',
        'DQN': 'regNumber',
        'Məbləğ (AZN)': 'paymentSum',
        'Məsul şəxs / Müştəri xidməti': 'clientServiceUserName',
        'F4': 'f4Export',
        'Subroqasiya': 'subragationExpert',

      },
    };
  },
  methods: {
    handleCommand(id) {
      this.handleEdit(id)
    },
    handleEdit(id) {
      let routeData = this.$router.resolve({ path: "../payment/claim/" + id });
      window.open(routeData.href, "_blank");
    },
    handleStatusView(id, type) {
      this.$refs["status"].view(id, type);
    },
    clickSearch() {
      this.filter.page = 1
      this.getData();
    },
    exportData() {
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.dataExport = 1;
      GetClaimsPayment(this.item).then((response) => {
        if (response.data.data) {
          this.exportDataList = response.data.data;
        }
      }).finally(() => {
        this.item.dataExport = 0;
      });
    },
    getData() {
      this.loading = true;
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.commandUserId = this.uid;
      this.item.pageNumber = this.filter.page;
      this.item.pageSize = this.filter.pagesize;
      this.item.dataExport = this.item.dataExport;
      GetClaimsPayment(this.item).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.data = response.data.data.map(item => ({
            ...item,
            f4Export: item.form4Status === 1 ? 'Var' : 'Yoxdur',
            subragationExpert: item.subragation === 1 ? 'Var' : 'Yoxdur'
          }));
          this.displayData = this.data;
          this.item.totalRecords =response.data.data?.[0].totalRecords;


        }
      });
    },
    loadTime() {
      this.item.startDate = AddMonths(new Date(), -6);
      this.item.endDate = AddDays(new Date(), +1);
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.filter.pagesize = val
      this.getData();
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
